import styled from 'styled-components';
import { rem } from 'polished';
import theme from '../../../common/styles/theme';
import { FontFamily } from '../../../utils/font';
import media from '../../../utils/media';

export const DesignatedPersonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  padding: ${rem('4px')} 0 ${rem('20px')} 0;
  box-sizing: border-box;

  ${media.phone`
    padding-bottom: ${rem('15px')};
  `};

  .isMasktrue {
    position: relative;
    color: transparent;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    &:before {
      content: '********';
      color: ${theme.greyNumberColor};
      position: absolute;
      left: 0;
      top: 0;
      width: max-content;
    }
  }
`;

export const DesignatedPersonValue = styled.span`
  ${FontFamily.BoldFontW01};
  font-size: ${rem('16px')};
  color: ${theme.blackColor};
  min-height: ${rem('20px')};

  ${media.phone`
    font-size: ${rem('14px')};
  `};
`;

export const RevealButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: ${rem('8px')};
  display: inline-flex;
  align-items: center;

  img {
    width: ${rem('20px')};
    height: ${rem('20px')};
  }

  &:focus {
    outline: 1px dotted ${theme.greyNumberColor};
  }
`;
